import React, { PropsWithChildren } from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { SkipLink, SkipLinkTarget } from '../../../_lib/components/SkipLink';
import { useHtmlValidId } from '../../../hooks/useHtmlValidId';

type CheckBoxList = {
  id?: string;
  ref?: React.RefObject<HTMLDivElement | null>;
};

export function CheckBoxList({ children, id, ref }: PropsWithChildren<CheckBoxList>) {
  const { t } = useSonTranslation('PrivilegeConfig');
  const listEndId = useHtmlValidId();

  return (
    <div className="privilege-config__checkbox-list" id={id} ref={ref}>
      <SkipLink id={listEndId} focusTarget>
        {t('jumpToListEnd')}
      </SkipLink>
      {children && <ul>{children}</ul>}
      <SkipLinkTarget id={listEndId} targetName={t('checkBoxListEnd')} />
    </div>
  );
}
